import { createStore } from '@ngneat/elf';
import { addEntities, deleteEntities, selectAllEntities, setEntities, updateEntities, withEntities } from '@ngneat/elf-entities';
import { Collection } from '../features/collections/models/collection';


export const store = createStore({ name: 'collection' }, withEntities<Collection>());

export const collections$ = store.pipe(selectAllEntities());

export function setCollection(collection: Collection[]) {
  store.update(setEntities(collection));
}

export function addCollection(collection: Collection) {
  store.update(addEntities(collection));
}

export function updateCollection(id: Collection['id'], collection: Partial<Collection>) {
  store.update(updateEntities(id, collection));
}

export function deleteCollection(id: Collection['id']) {
  store.update(deleteEntities(id));
}
